<template lang="pug">
.wagtail-titled-paragraphs
  .wagtail-titled-paragraphs-title(v-html="value.paragraph.title")
  .wagtail-titled-paragraph-body(v-html="value.paragraph.body")
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

